<template>
  <div>
    <el-image :src="require('@/assets/image/TradeTip/stabdardTariffHead.png')"></el-image>
    <div class="game-list">
      <div class="game-item" v-for="(item,index) in gameList" :key="index" @click="goToCus(item)">
        <div class="game-info">
          <el-image class="game-img" :src="item.img"></el-image>
          <div class="title">
            <div>{{ item.title1 }}</div>
          </div>
        </div>
        <div class="game-cus" >
          <div>{{ item.gameName }}</div>
          <div style="cursor: pointer">联系在线客服<i class="el-icon-arrow-right"></i></div>
        </div>
      </div>
    </div>
    <!--    <div class="hint"><i class="el-icon-warning"></i> 跳转失败请对照客服列表手动添加 ，客服QQ均为企业客服QQ，普通QQ均为骗子。</div>-->
    <div style="text-align: center">
      <el-image :src="require('@/assets/image/TradeTip/stabdardTariffOther.png')"
                style="width: 318px;margin-top:54px;margin-bottom: 34px"></el-image>
    </div>
    <div class="otherDescription">
      <div class="item">
        跳转在线客服之后，以客服发送的企业微信二维码为准辨别真伪。
      </div>
      <div class="item">
        买家付款以后，上号验号，与卖家描述相符即可过户账号资料。<br/>
      </div>
      <div class="item">
        <span>违约责任参考买卖家须知</span>
        <router-link :to="{name:'TradeTip',query:{id:'108',parent_id:'83'}}" class="itemClick" >
         &ensp;---------&ensp;卖家须知 <i class="el-icon-arrow-right"></i>
        </router-link>
      </div>
      <div class="item">
        若有特殊情况手续费发生变动的情况，以买、卖、平台三方最终协商为基准，交易前请与客服核对清楚并确认再开始交易流程。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "standardTariff",
  data() {
    return {
      gameList: [
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001021254_825941.png',
          gameName: '天刀端游',
          code: 'tymyd',
          title1: '号价的5%（最低200）+30上架费（上限2030）',
          title2: '天刀端游客服-奶茶 微信号：pxb7nc',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/2'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001024106_068248.png',
          gameName: '天刀手游',
          code: 'tdsy',
          title1: '号价的5%（最低50上限2030）',
          title2: '天刀手游客服-奶茶 微信号：pxb7nc',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/2'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001021952_847049.png',
          gameName: '剑灵端游',
          code: 'jianling',
          title1: '号价的5%（最低50）+30上架费',
          title2: '剑灵端游客服-大头 微信号：pxb7dt',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/3'
        },

        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001024209_495652.png',
          gameName: 'QQ三国',
          code: 'qqsg',
          title1: '3%（最低30）',
          title2: '游严选客服肉肉  微信号：pxb7rr',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/4'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023208_034052.png',
          gameName: '原神',
          code: 'yuanshen',
          title1: '5%（最低30上限1000）',
          title2: ' 原神客服-贝贝  微信号：pxb7bb',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/7'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211215/20211215171107_570079.png',
          gameName: '幻塔',
          code: 'huanta',
          title1: '5%（最低30）',
          title2: ' 原神客服-贝贝  微信号：pxb7bb',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/7'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023612_995562.png',
          gameName: '永劫无间',
          code: 'yjwj',
          title1: '5%（最低30）',
          title2: ' 原神客服-贝贝  微信号：pxb7bb',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/6'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023736_148771.png',
          gameName: '绝地求生',
          code: 'jdqs',
          title1: '5%（最低50）',
          title2: '王者荣耀客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/21'
        },

        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001024257_797181.png',
          gameName: '王者荣耀',
          code: 'wzry',
          title1: '5%（最低50）',
          title2: '王者荣耀客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/10'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001023336_673717.png',
          gameName: 'DNF-地下城与勇士',
          code: 'dxcyys1',
          title1: '5%（最低50）',
          title2: ' DNF客服-天天 微信号：pxb7tt',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/5'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001022953_568399.png',
          gameName: '英雄联盟',
          code: 'yxlm',
          title1: '5%（最低50）',
          title2: '王者荣耀客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/10'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001022112_462644.png',
          gameName: '和平精英',
          code: 'hpjy',
          title1: '5%（最低50）',
          title2: '和平精英客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/10'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211221/20211221172834_266054.jpg',
          gameName: '穿越火线',
          code: 'cyhx',
          title1: '5%（最低50）',
          title2: '和平精英客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/10'
        },
        {
          img: 'https://images.pxb7.com/images/game/20211001/20211001022743_811556.png',
          gameName: '超激斗梦境',
          code: 'cjdmj',
          title1: '5%（最低10）',
          title2: '和平精英客服-路飞   微信号：pxzhanghaohs',
          cus: 'https://tb.53kf.com/code/client/528d4f3bc25d9279010007a8c01daf5a4/5'
        },
      ]
    }
  },
  methods: {
    goToCus(item) {
      this.$openIM({
        ysdgcode: item.code,
        gameAlias: item.code,
      })
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .el-image {
  display: block;
}

.game-list {
  margin-top: 28px;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;

  .game-item {
    width: 380px;
    min-height: 132px;
    background: var(--bg-card, #FFFFFF);
    border: 1px solid var(--border-soft, #E8E4DE);
    box-shadow: 0 8px 20px rgba(26, 29, 36, 0.06);
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 20px 20px 0 20px;
    cursor: pointer;
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      border-color: rgba(26, 29, 36, 0.24);
      box-shadow: 0 12px 26px rgba(26, 29, 36, 0.1);
    }

    .game-info {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);

      .game-img {
        min-width: 60px;
        max-width: 60px;
        width: 60px;
        height: 60px;
        margin-right: 20px;
        border-radius: 4px;
        overflow: hidden;
      }

      .title {
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #111827);
        line-height: 22px;
      }
    }

    .game-cus {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 8px 0 11px 0;
      font-size: 14px;
      font-family: PingFangSC-Light, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;

      div:last-child {
        color: var(--primary, #FF5A1F);
      }
    }
  }
}

.hint {
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
  color: #9AA0AC;
  line-height: 22px;
  text-align: center;
}

.otherDescription {
  margin: 0 40px 72px;
  padding: 22px 24px;
  font-size: 16px;
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 400;
  color: var(--text-secondary, #5A5F6B);
  line-height: 24px;
  border: 1px solid var(--border-soft, #E8E4DE);
  border-radius: 4px;
  background: var(--bg-section, #F7F5F2);

  .item {
    margin-bottom: 12px;
    padding-left: 18px;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }

    .itemClick{
      font-size: 14px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--primary, #FF5A1F);
      cursor: pointer;
    }
    .itemClick:hover{
      color: var(--primary-hover, #E84A12);
    }

    &::after {
      content: '';
      width: 7px;
      height: 7px;
      background: var(--primary, #FF5A1F);
      position: absolute;
      top: 9px;
      left: 0;
      border-radius: 50%;
    }

    span {
      color: var(--text-main, #111827);
      font-weight: 600;
    }
  }
}
</style>
